import React from 'react';
import './App.css';
import TodoList from './components/TodoList';

function App() {
  return (
    <div className="clue-todo">
     <TodoList />
    </div>
  );
}

export default App;
